import type { Module } from '@efdigital/ll-addon-data';
import { debounce } from '@efdigital/ll-addon-ui/modifiers/debounce';
import { EditRecord } from '@efdigital/ll-admin-v2/components/edit-record.gts';
import { type EditRecordSignature } from '@efdigital/ll-admin-v2/components/edit-record-base.gts';
import { fn } from '@ember/helper';
import { set } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { type Store } from '@warp-drive/core';

import ImageEditorBig from '../pickers/image-picker-big.gts';

export class EditModuleContent extends Component<EditRecordSignature<Module>> {
  @service declare store: Store;

  setValue = (property: string, event: Event) => {
    const target = event.target as HTMLInputElement;
    set(this.args.item, property, target.value);
  };

  setMarkdown = (markdown: string) => {
    set(this.args.item, 'markdown', markdown);
  };

  handleIconChange = (value: string) => {
    set(this.args.item, 'icon', value);
  };

  <template>
    <EditRecord
      @editLabel="Edit Module Details"
      @item={{@item}}
      @context={{@context}}
      @maxDepth={{1}}
      ...attributes
    >
      <:form as |uniqueId isDisabled|>
        <fieldset disabled={{isDisabled}} class="mb-0">
          <legend class="gud-eyebrow">Module Details</legend>

          <div class="form-group mb-3">
            <label for="{{uniqueId}}-title" class="form-label required">Module
              Title</label>
            <input
              type="text"
              class="form-control"
              id="{{uniqueId}}-title"
              value={{@item.title}}
              required
              {{debounce (fn this.setValue "title")}}
            />
          </div>

          <div class="form-group mb-3">
            <label for="{{uniqueId}}-icon" class="form-label required">Module
              Image</label>
            <ImageEditorBig
              @value={{@item.icon}}
              @onChange={{this.handleIconChange}}
              @sizeHint="module-icon"
              @defaultTitle={{@item.title}}
              @readonly={{isDisabled}}
              @required={{true}}
              @id="{{uniqueId}}-icon"
              @placeholder="https://"
            />
          </div>
        </fieldset>
      </:form>
    </EditRecord>
  </template>
}
